import { Protocol } from "pmtiles";
import * as pmtiles from "pmtiles";
import { v4 as uuidv4 } from 'uuid';
import { extractTitleFromUrl, extractTypeFromLayerId } from "./util"

export const defaultSgeLayerOptions = {
  'paint': {
    'circle-color': 'rgba(255, 255, 255, 0)',
    'circle-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      1,    // change opacity to 1 on hover effect
      0.8   // opacity by default
    ],
    'circle-radius': [
      "interpolate",
      ["exponential", 2],
      ["zoom"],
      0, 0,
      21, ['*', 27, 2.2 ** 2]
    ],
  },
  'layout': {
    'visibility': 'visible'
  }
}

export const defaultFactorHexagonLayerOptions = {
  'paint': {
    'circle-color': '#F0D040',
    'circle-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      0.8,
      1
    ],
    'circle-radius': [
      "interpolate",
      ["exponential", 2],
      ["zoom"],
      0, 0,
      21, ['*', 27, 2.2 ** 2]
    ],
  },
  'layout': {
    'visibility': 'visible'
  }
}

const addCircleLayer = async (pmtilesUrl, map, prefix, layerOptions, zoomTo, layerIdFromBookmark) => {
  try {
    const uuid = uuidv4();
    const sourceId = `s-${uuid}`;
    const layerId = layerIdFromBookmark ? layerIdFromBookmark : `l-${prefix}-${uuid}`;
    const file = new pmtiles.PMTiles(pmtilesUrl);
    const meta = await file.getMetadata();
    // remove layer if already exists
    if (map.getLayer(layerId)) map.removeLayer(layerId);
    if (map.getSource(sourceId)) map.removeSource(sourceId);
    // add source
    if (!map.getSource(sourceId)) {
      map.addSource(sourceId, {
        "type": "vector",
        "url": "pmtiles://" + pmtilesUrl
      });
    };
    // add layer
    map.addLayer({
      'id': layerId,
      'type': 'circle',
      'source': sourceId,
      'source-layer': `sge`
      , ...layerOptions
    }, "gl-draw-line.cold"
    );
    if (zoomTo === true) {
      zoomToSource(map, map.getSource(sourceId));
    }
    return { sourceId: sourceId, layerId: layerId, meta: meta }
  } catch (err) {
    console.error("Error occurred adding a circle layer.");
    return null;
  }
}

export const addPMTilesCircleLayer = async (map, pmtilesUrl, layerOptions, prefix = 'pmtiles', zoomTo = false, catalogId, layerIdFromBookmark) => {

  const circleLayer = await addCircleLayer(pmtilesUrl, map, prefix, layerOptions, zoomTo, layerIdFromBookmark);

  return circleLayer ? {
    id: circleLayer.layerId,
    sourceId: circleLayer.sourceId,
    assetUrl: pmtilesUrl,
    assetType: extractTypeFromLayerId(circleLayer.layerId),
    title: extractTitleFromUrl(pmtilesUrl),
    catalogId: catalogId,
    meta: circleLayer.meta
  } : null;
}

export const addPMTilesCircleGroupLayer = async (map, pmtilesUrls, layerOptions, prefix = 'gene_group', zoomTo = false, catalogId, layerIdFromBookmark) => {
  // return if not an array or only one layer
  if (!Array.isArray(pmtilesUrls)) return;
  // the layer group will has an idential id and an array of sublayer ids
  const uuid = uuidv4();
  const layerId = layerIdFromBookmark ? layerIdFromBookmark : `l-${prefix}-${uuid}`;
  let subLayerIds = [];
  let sourceIds = [];
  const assetUrls = [];
  let assetTypes = "";
  let titles = [];
  const metas = [];
  for (let i = 0; i < pmtilesUrls.length; i++) {
    const subLayer = await addCircleLayer(pmtilesUrls[i], map, prefix, layerOptions, zoomTo);
    if (!subLayer) continue;
    subLayerIds.push(subLayer.layerId);
    sourceIds.push(subLayer.sourceId);
    assetUrls.push(pmtilesUrls[i]);
    assetTypes = extractTypeFromLayerId(subLayer.layerId);
    titles.push(extractTitleFromUrl(pmtilesUrls[i]));
    metas.push(subLayer.meta);
  }
  return subLayerIds.length > 0 ? {
    id: layerId,
    subLayerIds: subLayerIds,
    sourceId: sourceIds,
    assetUrl: assetUrls,
    assetType: assetTypes,
    title: titles,
    catalogId: catalogId,
    meta: metas
  } : null;
}

export const addPMTilesRasterLayer = async (map, pmtilesUrl, prefix = "bg", zoomTo = false, catalogId, layerIdFromBookmark) => {

  try {
    const uuid = uuidv4();
    const sourceId = `s-${uuid}`;
    const layerId = layerIdFromBookmark ? layerIdFromBookmark : `l-${prefix}-${uuid}`;
    const protocol = new Protocol();
    const file = new pmtiles.PMTiles(pmtilesUrl);
    protocol.add(file);

    // get metadata
    const fetchmeta = async () => {
      const meta = await file.getMetadata();
      if (!map.getSource(sourceId)) {
        map.addSource(sourceId, {
          "type": "raster",
          "url": "pmtiles://" + pmtilesUrl
        });
      };

      map.addLayer({
        'id': layerId,
        'type': 'raster',
        'source': sourceId,
        'minzoom': 7,
        'maxzoom': 21,
        'paint': {
          'raster-opacity': 0.85
        },
        'layout': {
          'visibility': 'visible'
        }
      }, "gl-draw-line.cold");
      if (zoomTo === true) {
        zoomToSource(map, map.getSource(sourceId));
      }
      return meta;
    }
    const meta = await fetchmeta();

    return {
      sourceId: sourceId,
      id: layerId,
      assetUrl: pmtilesUrl,
      assetType: extractTypeFromLayerId(layerId),
      title: extractTitleFromUrl(pmtilesUrl),
      catalogId: catalogId,
      meta: meta
    }
  } catch (err) {
    console.error("Error occurred adding a raster layer.");
    return null;
  }
}

export const zoomToSource = (map, source) => {
  setTimeout(() => {
    map.fitBounds(source.bounds);
  }, 1500);

}

